// extracted by mini-css-extract-plugin
export default {"container":"Callout-module__container--7116"};